import { TLowStockVariantId } from '@services/MarppleShop/features/ProductMeta';
import { Html, html } from 'rune-ts';
import { getResizedUrl } from '@services/MarppleShop/shared/util/image.ts';
import { Localized } from '../../../../../../shared/type';

export const LOW_STOCK_VARIANT_LABEL: Record<TLowStockVariantId, string> = {
  THRESHOLD_INFINITY: '항상 공개',
  THRESHOLD_10: '총 10개 미만 시',
  THRESHOLD_100: '총 100개 미만 시',
};

export const INTL_ICONS: Localized<Html> = {
  kr: html`<img
    src="${getResizedUrl({
      url: '//s3.marpple.co/files/u_1514961/2025/8/original/4df8bb91d78923c24382631910db5adf8ee8bf7c1.png',
      width: 20 * 2.5,
      quality: 85,
    })}"
    alt=""
  />`,

  en: html`<img
    src="${getResizedUrl({
      url: '//s3.marpple.co/files/u_1514961/2025/8/original/b54e8ca6b925d684424e29d330ef5adedd8eb20f2.png',
      width: 20 * 2.5,
      quality: 85,
    })}"
    alt=""
  />`,

  jp: html`<img
    src="${getResizedUrl({
      url: '//s3.marpple.co/files/u_1514961/2025/8/original/bc48193daba234d2d126bdea5a695c6b601adb8c3.png',
      width: 20 * 2.5,
      quality: 85,
    })}"
    alt=""
  />`,
};

export const ACTIONS = {
  DELETE: {
    key: 'DELETE',
    name: '삭제하기',
  },
  DUPLICATE: {
    key: 'DUPLICATE',
    name: '상품 복제하기',
  },
  PROHIBIT: {
    key: 'PROHIBIT',
    name: '판매 보류하기',
  },
  REPORT: {
    key: 'REPORT',
    name: '신고 처리',
  },
  TO_TPL: {
    key: 'TO_TPL',
    name: '입고전환',
  },
} as const;

export type ACTIONS = keyof typeof ACTIONS;

/**
 * 폼 관련 메시지 상수
 */
export const MESSAGES = {
  SAVE: {
    FAILED: '저장에 실패했습니다.',
    SUCCESS: '저장되었습니다.',
  },
  TEMP_SAVE: {
    TITLE: '이전 임시저장 삭제',
    EXIST_CONFIRM:
      '이미 임시저장한 상품이 존재합니다.\n이전 상품은 삭제하고 현재 등록 중인 상품을\n임시저장하시겠습니까?',
    SUCCESS_TITLE: '임시저장 완료',
    SUCCESS_MESSAGE: '등록 중인 상품이 임시저장되었습니다.',
  },
  DELETE: {
    TITLE: '상품 삭제하기',
    HAS_UP_TITLE: '삭제 불가 안내',
    HAS_UP_MESSAGE:
      '이미 판매되었거나 장바구니에 담긴 상품은\n삭제할 수 없습니다.\n노출을 원하지 않을 경우 비공개로 전환해 주세요.',
    CONFIRM: '삭제한 상품은 복구할 수 없습니다.\n상품을 삭제하시겠습니까?',
    FAILED: '삭제 실패했습니다.',
  },
  DUPLICATE: {
    TITLE: '상품 복사',
    FORBIDDEN: '복사가 불가능한 상품입니다. 개발팀에 문의하세요.',
  },
  PROHIBIT: {
    TITLE: '판매 보류',
    CANCEL_TITLE: '판매 보류 취소하기',
    CONFIRM:
      "해당 상품을 판매 보류하시겠습니까?\n판매 보류 시 상품 공개 상태가 '비공개'로 변경되며\n즉시 판매가 중지됩니다.",
    CANCEL_CONFIRM:
      '해당 상품의 판매 보류를 취소하시겠습니까?\n판매 보류 취소 시 상품 공개 상태가 활성화됩니다.',
    FAILED: '판매 보류 실패했습니다.',
  },
  TO_TPL: {
    TITLE: '입고 상품으로 전환',
    CONFIRM: '옵션 직접 입력형이 설정되어 있는 경우\n입고상품으로 전환시 삭제됩니다.',
    FORBIDDEN: '입고 상품으로 전환할 수 없는 스토어 입니다.',
    FAILED_TITLE: '입고 전환 불가 안내',
  },
  SKU: {
    TITLE: '입고 상품 등록 안내',
    DUPLICATED_NICKNAME: '중복된 재고관리번호가 존재합니다.',
    PUBLIC_SKU:
      '재고관리번호를 입력하지 않은 경우 자동생성됩니다.\n입고 상품을 등록한 후엔 옵션, 재고관리번호,\n상품 카테고리는 수정할 수 없습니다.',
    NOT_PUBLIC_SKU: '입고 상품을 등록한 후엔 옵션, 재고관리번호,\n상품 카테고리는 수정할 수 없습니다.',
  },
  VALIDATION: {
    EMPTY_THUMBNAIL_TITLE: '대표 이미지 업로드 필요',
    EMPTY_THUMBNAIL_MESSAGE: '등록된 대표 이미지가 없습니다.\n업로드 후 다시 시도해 주세요.',
    VOLUME_TITLE: '체적정보 입력 필요',
    VOLUME_MESSAGE: '해외 배송의 경우, 정확한 배송비 계산을 위해\n모든 옵션 목록의 체적정보를 입력해 주세요.',
  },
  ERROR: {
    UNEXPECTED_TITLE: '예상치 못한 에러가 발생했습니다.',
    STOCK_EXCEEDED_TITLE: '입력 가능 재고 초과',
    OPTION_PRICE_EXCEEDED_TITLE: '옵션 추가 금액 초과',
  },
  BUTTON: {
    SAVE: '저장',
    CANCEL: '취소',
    CONFIRM: '확인',
    DELETE: '삭제',
    REGISTER: '등록하기',
    PROHIBIT: '판매 보류',
    PROHIBIT_CANCEL: '보류 취소',
  },
} as const;
